import template from './about-land.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'aboutLandCtrl',
    replace: true,
  };
};
